/* @jsxImportSource react */
'use client';

import { Box, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

export interface OrDividerProps {
  /**
   * Center label. Kept readable (not `aria-hidden`) because it carries meaning
   * — the alternative-method boundary between stacks.
   * @default "Or"
   */
  label?: string;
  className?: string;
}

/**
 * The "Or" hairline separator between auth methods. Atoms has no Divider, so
 * this composes two decorative rules flanking the label.
 */
export const OrDivider = ({ label = 'Or', className }: OrDividerProps) => (
  <Row className={cn('w-full items-center gap-3', className)}>
    <Box className="flex-1 border-t border-od-border-primary" aria-hidden />
    <Text as="span" className="text-body-sm text-od-content-tertiary">
      {label}
    </Text>
    <Box className="flex-1 border-t border-od-border-primary" aria-hidden />
  </Row>
);

OrDivider.displayName = 'OrDivider';
